import React from "react";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";
import styles from "./styles.module.scss";

export function Success() {
  var { tSurvey: t } = useAppTranslation.Survey();

  return (
    <div className={styles.root}>
      <p>{t("success.text")}</p>
      <h2>{t("success.title")}</h2>
    </div>
  );
}
